import { render, staticRenderFns } from "./mailMessage.vue?vue&type=template&id=14423026&scoped=true"
import script from "./mailMessage.vue?vue&type=script&lang=js"
export * from "./mailMessage.vue?vue&type=script&lang=js"
import style0 from "./mailMessage.vue?vue&type=style&index=0&id=14423026&prod&lang=scss&scoped=true"
import style1 from "./mailMessage.vue?vue&type=style&index=1&id=14423026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14423026",
  null
  
)

export default component.exports